// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-detail {\n  position: relative;\n}\n.dashboard-detail .content {\n  padding-bottom: 26px;\n}\n.dashboard-detail .header {\n  color: rgba(0, 0, 0, 0.85);\n  padding: 0 0 24px 24px;\n  border-bottom: 1px solid #f0f0f0;\n  background: #fff;\n  padding-top: 20px;\n}\n.dashboard-detail .el-dialog__wrapper .el-input,\n.dashboard-detail .el-dialog__wrapper .el-textarea {\n  width: 348px !important;\n}", ""]);
// Exports
module.exports = exports;
